import styled from 'styled-components';
import { device } from '../utils/deviceSizes';

export const SignupStyles = styled.div`
  margin-bottom: 10rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 2rem;

  @media ${device.mobileL} {
    margin-bottom: 5rem;
  }

  input,
  textarea,
  select {
    font-size: 16px;
    padding: 0.5rem;
  }
  h1 {
    margin: 2rem 0;
    text-align: center;
    font-size: 3rem;
    
    @media ${device.tablet} {
      font-size: 2.4rem;
      padding: 0 1rem;
    }
    @media ${device.mobileL} {
      font-size: 2rem;
    }
  }

  h2 {
    text-align: center;
    width: 100%;
  }

  .steps {
    min-width: 55rem;
    display: flex;
    justify-content: center;
    gap: 4rem;
    padding: 5rem;
    
    @media ${device.tablet} {
      display: none;
    }

    li {
      border-bottom: 2px solid transparent;
      &.active {
        color: var(--primary);
        border-color: var(--primary);
      }
    }
  }

  .span-2 {
    grid-column: 1/3;
  }

  form {
    min-width: 55rem;
    display: flex;
    flex-direction: column;
    gap: 2rem;
    align-items: start;
    width: 100%;

    @media ${device.tablet} {
      min-width: 100%;
    }

    .fields-wrapper {
      width: 500px;
      margin: 0 auto;
      background-color: transparent;
      display: none; /* hide by default */
      gap: 1rem;
 
      &.store-type {
        width: fit-content;
      }

      @media ${device.tablet} {
        width: 100%;
        
      }
      /* Only display when active */
      &.active {
        display: flex;
        flex-direction: column;
      }

      &.grid-cols-1 {
        display: none;
        flex-direction: column;

        &.active {
          display: flex;
        }

        label {
          text-align: left;
        }

        input {
          width: 100%;
          padding: 1rem;
        }
      }
    }

    .form-control {
      width: 100%;
      display: flex;
      flex-direction: column;
      gap: 1rem;
      font-size: 1.8rem;

      .react-select {
        color: #000;
      }

     
      &.phone-select {
        display: grid;
        grid-template-columns: 1fr 1fr;
        align-items: end;

        label {
          font-size: 1.4rem;
          font-style: italic ;
        }
        
        p {
          grid-column: 1/3;
        }
      }

      label {
        display: flex;
        flex-direction: column;
        width: 100%;
      }
    }

    button {
      grid-column: 1/3;
      width: 100%;
    }
  }

  .error {
    color: var(--red);
  }

  .buttons-container {
    display: flex;
    align-items: center;
    flex-direction: row;
    gap: 2rem;
    width: 100%;

    @media ${device.mobileL} {
      flex-direction: column;
    }

    a {
      font-size: 1.6rem;
      text-decoration: underline;
    }

    button {
      width: 100%;
    }
  }

  .google-wrapper {
    font-size: 1.8rem;

    p:first-child {
      font-style: italic;
      font-size: 1.4rem;
    }

    input {
      width: 100%;
      padding: 0.5rem;
    }
  }

  .store-type-picker {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    gap: 2rem;
    width: 100%;

    @media ${device.laptopM} {

      grid-template-columns: 1fr 1fr;
    }
    @media ${device.tablet} {
      grid-template-columns: 1fr;
    }
/* 
    @media ${device.mobileL} {
      grid-template-columns: 1fr;
    } */

    li {
      display: flex;
      flex-direction: column;
      background-color: var(--darkGrey1);
      span {
        padding: 0.5rem;
      }
      img {
        object-fit: cover;
      }
    }
  }
`;
